import { Link } from "react-router-dom";
import { CLOUDINARY_BASE_URL } from "../../config/cloudinary";
import { useLanguage } from "../../contexts/LanguageContext";
import { blogText } from "../../i18n/blog";
import { trackCtaClick } from "../../utils/analytics";
import styles from "./BlogMemoryCta.module.scss";

const ctaImages = {
  "photo-tour": `${CLOUDINARY_BASE_URL}v1784682749/DJI_20260721090315_0012_D_ndyr5p.webp`,
  "jet-tour": `${CLOUDINARY_BASE_URL}v1784949980/DJI_20260724131535_0015_D_robale.webp`,
  "surfing-tour": `${CLOUDINARY_BASE_URL}v1784350164/DJI_20260708172917_0004_D_n0pzoh.webp`,
  tour: `${CLOUDINARY_BASE_URL}v1784682749/DJI_20260721090315_0012_D_ndyr5p.webp`,
};

const getTourCategory = (path) => {
  if (path?.includes("/surfing")) return "surfing-tour";
  if (path?.includes("/jet-private-secret-tour")) return "jet-tour";
  if (path?.includes("/one-day-photogenic-tour")) return "photo-tour";
  return "tour";
};

const splitTitle = (title, fallback) => {
  if (Array.isArray(title)) return title;
  if (typeof title !== "string" || !title.trim()) return fallback;

  const normalizedTitle = title.trim();
  const separatorIndex = normalizedTitle.search(/[、。・｜|]/);

  if (separatorIndex > 0 && separatorIndex < normalizedTitle.length - 1) {
    return [
      normalizedTitle.slice(0, separatorIndex + 1),
      normalizedTitle.slice(separatorIndex + 1),
    ];
  }

  if (normalizedTitle.length > 15) {
    const middle = Math.ceil(normalizedTitle.length / 2);
    return [normalizedTitle.slice(0, middle), normalizedTitle.slice(middle)];
  }

  return [normalizedTitle, ""];
};

const BlogMemoryCta = ({ to = "/tours/one-day-photogenic-tour", cta = {} }) => {
  const { lang } = useLanguage();
  const t = blogText[lang] || blogText.JP;
  const titleLines = splitTitle(cta.title, t.ctaTitle);
  const ctaText = cta.text || t.ctaText;
  const ctaButton = cta.buttonText || t.ctaButton;
  const tourCategory = getTourCategory(to);
  const ctaImage = ctaImages[tourCategory] || ctaImages.tour;

  return (
    <section
      className={styles.root}
      style={{ "--blog-memory-cta-image": `url(${ctaImage})` }}
    >
      <div>
        <span className={styles.script}>{t.ctaScript}</span>
        <h2>
          {titleLines[0]}
          {titleLines[1] && (
            <>
              <br />
              {titleLines[1]}
            </>
          )}
        </h2>
        <p>{ctaText}</p>
      </div>

      <Link
        to={to}
        title={ctaButton}
        aria-label={ctaButton}
        data-seo-link={`${tourCategory}-memory-cta`}
        data-tour-category={tourCategory}
        data-tour-path={to}
        onClick={() =>
          trackCtaClick({
            label: `blog_memory_cta_${tourCategory}`,
            placement: "blog_memory_cta",
            destination: to,
            destinationType: "internal_tour",
          })
        }
      >
        {ctaButton}
      </Link>
    </section>
  );
};

export default BlogMemoryCta;
